module.exports = __webpack_public_path__ + "static/media/01G.e8a05dfc.png";